module.exports = "/out/52faa126bbcf5fc50df0428e97bcbd44.jpg";